import { Tabs } from "antd";
import React, { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useProgressPerfomanceTabs from "../../lib/hooks/useProgressPerformanceTabs";
import SearchIndicatorProvider from "./indicator/searchContext";
import WithSidebar from "../../templates/withSidebar";
import Indicator from "./indicator";
import SearchPerfomanceProvider from "./performance/searchContext";
import Perfomance from "./performance";
import KPI from "./kpi";

const ProgressPerfomance = () => {
  const navigate = useNavigate();
  const { tabs, setTabs } = useProgressPerfomanceTabs();
  const [searchParams] = useSearchParams();
  const currentMenu = searchParams.get("management");
  const currentTab = searchParams.get("tab");

  const setChangeTabfromState = useCallback(
    (tab) => {
      setTabs(tab);
    },
    [setTabs]
  );

  useEffect(() => {
    setChangeTabfromState(currentTab);
  }, [currentMenu, currentTab]);

  const onChangeTab = (key) => {
    setTabs(key);
    navigate({
      pathname: `/progress-performance`,
      search: `?menu=progress&tab=${key}`,
    });
  };

  const items = [
    {
      key: "kpi",
      label: <strong>แผนยุทธศาสตร์</strong>,
      children: (
        <SearchIndicatorProvider>
          <KPI />
        </SearchIndicatorProvider>
      ),
    },
    {
      key: "indicator",
      label: <strong>รายงานผลตัวชี้วัด</strong>,
      children: (
        <SearchIndicatorProvider>
          <Indicator />
        </SearchIndicatorProvider>
      ),
    },
    {
      key: "performance",
      label: <strong>รายงานผลการดำเนินงานตามแผนปฏิบัติการ</strong>,
      children: (
        <SearchPerfomanceProvider>
          <Perfomance />
        </SearchPerfomanceProvider>
      ),
    },
  ];

  return (
    <WithSidebar>
      <Tabs activeKey={tabs} items={items} onChange={onChangeTab} />
    </WithSidebar>
  );
};

export default ProgressPerfomance;
